/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import makeRequest from 'utils/makeRequest';
// import { isIOS } from 'utils/common';
import Card from 'components_v2/common/CardV2';
import s from './MobileCarousel.scss';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class MobileCarousel extends React.Component {
  constructor() {
    super();
    this.carouselData = [];
    this.state = {
      mounted: false,
      updatedimgPixel: '',
    };
  }

  /**
   * Checking for presence of the geolocation
   * for the US will be loading this widget
   */
  isGeoInfoPresent = () =>
    typeof window !== 'undefined' &&
    _get(window, 'geoinfo.CountryCode', '') === 'US';

  /**
   * fetch the data
   */
  fetchData = () => {
    makeRequest
      .get(this.props.url)
      .then(data => {
        if (data.status === 200 && data.data) {
          this.carouselData = data.data;
          if (this.props.imgPixel) {
            const unixTimestamp = Date.now();
            const withNewData = this.props.imgPixel.replace(
              '__TIME__',
              unixTimestamp,
            );
            this.setState({ updatedimgPixel: withNewData });
          }
        }
      })
      .catch(err => {
        if (this.timer) {
          clearInterval(this.timer);
        }
        console.log(err);
      });
  };

  /**
   * is Data available to show
   */
  checkIsDataAvailable = () =>
    Array.isArray(this.carouselData) && this.carouselData.length > 0;

  checkIsComponentMounted = () => {
    if (this.isGeoInfoPresent() && this.checkIsDataAvailable()) {
      this.setState({ mounted: true });
    } else {
      this.timer = setInterval(() => {
        if (this.isGeoInfoPresent() && this.checkIsDataAvailable()) {
          this.setState({ mounted: true });
          clearInterval(this.timer);
        }
      }, 1000);
    }
  };

  componentDidMount() {
    /**
     * Carousal will be placed for Timesclub in IOS or Willow across but in US Geo only
     */
    if (this.props.isWillowTv) {
      this.fetchData();
      this.checkIsComponentMounted();
    }
  }

  render() {
    const sectionName = this.props.name;
    const { ga4Type } = this.props;
    const { updatedimgPixel } = this.state;
    if (this.state.mounted) {
      return (
        <InViewObserver
          inViewCallback={() => {
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: ga4Type,
              });
            }
          }}
        >
          <div className={s.carouselContainer}>
            <h2>{sectionName}</h2>
            <div className={s.carouselCard}>
              {this.carouselData.map((card, index) => (
                <Card
                  data={card}
                  isVerticalTile
                  newga={`${sectionName}_slider#${sectionName}_Click/${index}`}
                  cssObj={{
                    figureClass: s.figure,
                    imgCont: s.image,
                    titleCont: s.title,
                  }}
                  ga4Type={ga4Type}
                  gaIndex={index + 1}
                />
              ))}
            </div>
          </div>
          {updatedimgPixel && (
            <img
              src={updatedimgPixel}
              border="0"
              width="1"
              height="1"
              alt="pixel_1x1"
            />
          )}
        </InViewObserver>
      );
    }
    return null;
  }
}

MobileCarousel.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string,
  isWillowTv: PropTypes.bool,
  ga4Type: PropTypes.string,
  imgPixel: PropTypes.string,
};

MobileCarousel.defaultProps = {
  name: '',
  isWillowTv: false,
  ga4Type: '',
  imgPixel: '',
};

export default MobileCarousel;
